import BaseAPI from './base/base-api'

/**
 * Đầu api để gọi vào controller: TaxReturnSubmissionController
 */
class EconomicTaxReturnSubmissionAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'DeclareAPI';
    controllerName = 'economictaxreturnsubmission';
}

export default new EconomicTaxReturnSubmissionAPI();